"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableActionEdit_1 = require("../../../../../../../../shared/components/table_actions/TableActionEdit");
var TableActionAudit_1 = require("../../../../../../../../shared/components/table_actions/TableActionAudit");
var BrandMessageTemplatesList = /** @class */ (function (_super) {
    __extends(BrandMessageTemplatesList, _super);
    function BrandMessageTemplatesList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            data: [],
            loading: true,
            totalRows: 0
        };
        return _this;
    }
    BrandMessageTemplatesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total,
                loading: false
            });
        });
        this.props.data.LoadData(this.props.rootRecord.key);
        this.props.state.setExtBreadCrumbPath(["Sms Шаблоны бренда"]);
    };
    BrandMessageTemplatesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BrandMessageTemplatesList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            if (nextProps.rootRecord.key != this.props.rootRecord.key) {
                nextProps.data.LoadData(nextProps.rootRecord.key);
            }
        }
    };
    BrandMessageTemplatesList.prototype.columns = function () {
        var _this = this;
        return [
            {
                title: 'Название',
                dataIndex: this.props.data.dk_title,
                key: this.props.data.dk_title,
                width: 200,
            }, {
                title: 'Язык шаблона',
                dataIndex: this.props.data.dk_app_language_title,
                key: this.props.data.dk_app_language_title,
                width: 150,
            }, {
                title: 'Действие',
                dataIndex: this.props.data.dk_message_action_title,
                key: this.props.data.dk_message_action_title,
                width: 250,
            }, {
                title: 'Описание',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 250,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionAudit_1.default, { hint: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u043E\u043C", onClick: function () { _this.onEditTemplateOperationClick(record); } }),
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteProviderClick(record); } }))); },
                width: 100
            }
        ];
    };
    BrandMessageTemplatesList.prototype.onEditTemplateOperationClick = function (record) {
        if (this.props.onTemplateOperationClick) {
            this.props.onTemplateOperationClick(record);
        }
    };
    BrandMessageTemplatesList.prototype.onEditClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BrandMessageTemplatesList.prototype.onDeleteProviderClick = function (record) {
        var _this = this;
        this.props.data.DeleteGwsMessageTemplate(record.key, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0428\u0430\u0431\u043B\u043E\u043D ",
                    React.createElement("b", null,
                        "[",
                        record.title,
                        "]"),
                    " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
            });
        });
    };
    BrandMessageTemplatesList.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            this.setState({ loading: true }, function () {
                _this.props.data.LoadData(_this.props.rootRecord.key, function () {
                    _this.setState({ loading: false });
                });
            });
        }
        if (action === "back") {
            if (this.props.onGoBack) {
                this.props.onGoBack();
            }
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    BrandMessageTemplatesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { back: "Вернуться", refresh: "Обновить", create: "Создать" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns(), dataSource: this.state.data, loading: this.state.loading, pagination: {
                    defaultPageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return (React.createElement("div", { style: { margin: 0, display: "flex", flexDirection: "row", flexWrap: "nowrap" } },
                    React.createElement("div", { style: { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", flexWrap: "nowrap" } },
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0414\u0430\u0442\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F:"),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0414\u0430\u0442\u0430 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F:"),
                            " [",
                            record.date_changed.format(_this.props.state.getDateTimeFormat()),
                            "]")))); }, scroll: { x: true } })));
    };
    return BrandMessageTemplatesList;
}(React.Component));
exports.default = BrandMessageTemplatesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/message/BrandMessageTemplatesList.tsx
// module id = 1804
// module chunks = 0